import EmployeeSidebar from "../../components/employee/EmployeeSidebar";
import { Outlet } from "react-router-dom";

export default function EmployeeLayout() {
    return (
        <div className="flex min-h-screen bg-slate-100">

            <EmployeeSidebar />

            <main className="flex-1 overflow-auto">
                <div className="max-w-screen-2xl mx-auto p-8">
                    <Outlet />
                </div>
            </main>

        </div>
    );
}